import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import { Typography } from '@mui/material';
import useStyles from './styles';
export default function AllocationProgressBar(_ref) {
  let totalSteps = _ref.totalSteps,
    completedSteps = _ref.completedSteps;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const progressPercentage = totalSteps ? Math.floor(completedSteps / totalSteps * 100) : 0;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.progressContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('allocations.progress')), /*#__PURE__*/React.createElement("div", {
    className: classes.progress
  }, [...Array(totalSteps)].map((elem, i) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.progressPartial, " ").concat(i < completedSteps ? classes.activeStep : classes.unactiveStep),
    key: uuid()
  }))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, progressPercentage, "% ", t('allocations.completed')));
}